// html-parser.service.ts
import { Injectable } from '@angular/core';
export interface HtmlNode {
  tag: string;
  attributes: { [key: string]: string };
  text?: string;
  children?: HtmlNode[];
}

@Injectable({ providedIn: 'root' })
export class HtmlParserService {
  parseHtml(html: string): HtmlNode[] {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return this.parseChildren(doc.body);
  }

  private parseChildren(parent: HTMLElement): HtmlNode[] {
    const nodes: HtmlNode[] = [];

    for (const child of Array.from(parent.childNodes)) {
      if (child.nodeType === Node.TEXT_NODE) {
        const text = child.textContent;
        if (text) {
          nodes.push({ tag: 'text', attributes: {}, text });
        }
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        const element = child as HTMLElement;
        const attributes: { [key: string]: string } = {};
        for (const attr of Array.from(element.attributes)) {
          attributes[attr.name] = attr.value;
        }

        nodes.push({
          tag: element.tagName.toLowerCase(),
          attributes,
          children: this.parseChildren(element),
        });
      }
    }

    return nodes;
  }
}
